// Generated by Melange

import * as Caml_format from "melange.js/caml_format.js";
import * as Caml_int64 from "melange.js/caml_int64.js";
import * as Caml_js_exceptions from "melange.js/caml_js_exceptions.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Caml_string from "melange.js/caml_string.js";
import * as Curry from "melange.js/curry.js";
import * as Ocaml_protoc_plugin__Json from "./json.js";
import * as Ocaml_protoc_plugin__Ptime from "./ptime.js";
import * as Ocaml_protoc_plugin__Result from "./result.js";
import * as Stdlib from "melange/stdlib.js";
import * as Stdlib__BytesLabels from "melange/bytesLabels.js";
import * as Stdlib__Char from "melange/char.js";
import * as Stdlib__Int64 from "melange/int64.js";
import * as Stdlib__List from "melange/list.js";
import * as Stdlib__ListLabels from "melange/listLabels.js";
import * as Stdlib__Map from "melange/map.js";
import * as Stdlib__String from "melange/string.js";
import * as Stdlib__StringLabels from "melange/stringLabels.js";
import * as Stdlib__Sys from "melange/sys.js";

const FieldMap = Stdlib__Map.Make({
      compare: Stdlib__StringLabels.compare
    });

function value_error(type_name, json) {
  return Ocaml_protoc_plugin__Result.raise({
              NAME: "Wrong_field_type",
              VAL: [
                type_name,
                Ocaml_protoc_plugin__Json.to_string(json)
              ]
            });
}

function to_int64(json) {
  if (typeof json === "string") {
    return value_error("int64", json);
  }
  const variant = json.NAME;
  if (variant === "String") {
    return Caml_format.caml_int64_of_string(json.VAL);
  } else if (variant === "Int") {
    return Caml_int64.of_int32(json.VAL);
  } else {
    return value_error("int64", json);
  }
}

function to_int(json) {
  return Caml_int64.to_int32(to_int64(json));
}

function to_int32(json) {
  if (typeof json === "string") {
    return value_error("int32", json);
  }
  const variant = json.NAME;
  if (variant === "String") {
    return Caml_format.caml_int32_of_string(json.VAL);
  } else if (variant === "Int") {
    return json.VAL;
  } else {
    return value_error("int32", json);
  }
}

function to_string(json) {
  if (typeof json === "string" || json.NAME !== "String") {
    return value_error("string", json);
  } else {
    return json.VAL;
  }
}

function to_bytes(json) {
  return Stdlib__BytesLabels.of_string(to_string(json));
}

function to_float(json) {
  if (typeof json === "string") {
    return value_error("float", json);
  }
  const variant = json.NAME;
  if (variant === "String") {
    return Caml_format.caml_float_of_string(json.VAL);
  } else if (variant === "Int" || variant === "Float") {
    return json.VAL;
  } else {
    return value_error("float", json);
  }
}

function to_bool(json) {
  if (typeof json === "string") {
    return value_error("bool", json);
  }
  const variant = json.NAME;
  if (variant !== "String") {
    if (variant === "Bool") {
      return json.VAL;
    } else {
      return value_error("bool", json);
    }
  }
  switch (json.VAL) {
    case "false" :
        return false;
    case "true" :
        return true;
    default:
      return value_error("bool", json);
  }
}

function to_list(json) {
  if (typeof json === "string" || json.NAME !== "List") {
    return value_error("list", json);
  } else {
    return json.VAL;
  }
}

function read_map(read_key, read_value, json) {
  if (typeof json === "string" || json.NAME !== "Assoc") {
    return value_error("map_entry", json);
  } else {
    return Stdlib__ListLabels.map((function (param) {
                  const key = Curry._1(read_key, param[0]);
                  const value = Curry._1(read_value, param[1]);
                  return [
                          key,
                          value
                        ];
                }), json.VAL);
  }
}

function duration_of_json(json) {
  try {
    const s = to_string(json);
    if (Caml_string.get(s, s.length - 1 | 0) !== /* 's' */115) {
      throw new Caml_js_exceptions.MelangeError("Assert_failure", {
                MEL_EXN_ID: "Assert_failure",
                _1: [
                  "vendored/ocaml_protoc_plugin/deserialize_json.ml",
                  69,
                  4
                ]
              });
    }
    const match = Caml_string.get(s, 0) === /* '-' */45 ? [
        -1,
        Stdlib__StringLabels.sub(s, 1, s.length - 2 | 0)
      ] : [
        1,
        Stdlib__StringLabels.sub(s, 0, s.length - 1 | 0)
      ];
    const sign = match[0];
    const match$1 = Stdlib__StringLabels.split_on_char(/* '.' */46, match[1]);
    let match$2;
    if (match$1) {
      const match$3 = match$1.tl;
      const seconds = match$1.hd;
      match$2 = match$3 ? (
          match$3.tl ? Stdlib.failwith("Too many '.' in string") : [
              seconds,
              match$3.hd
            ]
        ) : [
          seconds,
          "000"
        ];
    } else {
      match$2 = Stdlib.failwith("Too many '.' in string");
    }
    const nanos = match$2[1];
    const seconds$1 = Caml_format.caml_int_of_string(match$2[0]);
    const match$4 = nanos.length;
    let nano_fac;
    switch (match$4) {
      case 3 :
          nano_fac = 1000000;
          break;
      case 6 :
          nano_fac = 1000;
          break;
      case 4 :
      case 5 :
      case 7 :
      case 8 :
          nano_fac = Stdlib.failwith("Nanos should be either 0, 3, 6 or 9 digits");
          break;
      case 9 :
          nano_fac = 1;
          break;
      default:
        nano_fac = Stdlib.failwith("Nanos should be either 0, 3, 6 or 9 digits");
    }
    const nanos$1 = Math.imul(Caml_format.caml_int_of_string(nanos), nano_fac);
    if (!(seconds$1 >= 0 && nanos$1 >= 0)) {
      throw new Caml_js_exceptions.MelangeError("Assert_failure", {
                MEL_EXN_ID: "Assert_failure",
                _1: [
                  "vendored/ocaml_protoc_plugin/deserialize_json.ml",
                  88,
                  4
                ]
              });
    }
    return [
            Math.imul(seconds$1, sign),
            Math.imul(nanos$1, sign)
          ];
  }
  catch (exn){
    return value_error("google.protobuf.duration", json);
  }
}

function timestamp_of_json(json) {
  if (typeof json === "string") {
    return value_error("google.protobuf.timestamp", json);
  }
  if (json.NAME !== "String") {
    return value_error("google.protobuf.timestamp", json);
  }
  const timestamp = json.VAL;
  const _e = Ocaml_protoc_plugin__Ptime.of_rfc3339(undefined, undefined, undefined, timestamp);
  let t;
  t = _e.TAG === /* Ok */0 ? _e._0[0] : value_error("google.protobuf.duration", {
          NAME: "String",
          VAL: timestamp
        });
  const seconds = Caml_int64.of_float(Ocaml_protoc_plugin__Ptime.to_float_s(t));
  const nanos = Caml_int64.of_float(1000000000.0 * Ocaml_protoc_plugin__Ptime.Span.to_float_s(Ocaml_protoc_plugin__Ptime.frac_s(t)));
  return [
          seconds,
          nanos
        ];
}

function from_camel_case(s) {
  const is_lowercase = function (c) {
    if (Stdlib__Char.lowercase_ascii(c) === c) {
      return Stdlib__Char.uppercase_ascii(c) !== c;
    } else {
      return false;
    }
  };
  const is_uppercase = function (c) {
    if (Stdlib__Char.lowercase_ascii(c) !== c) {
      return Stdlib__Char.uppercase_ascii(c) === c;
    } else {
      return false;
    }
  };
  const map = function (param) {
    if (!param) {
      return /* [] */0;
    }
    const c1 = param.hd;
    const match = param.tl;
    if (!match) {
      return {
              hd: c1,
              tl: map(param.tl)
            };
    }
    const c2 = match.hd;
    if (is_lowercase(c1) && is_uppercase(c2)) {
      return {
              hd: c1,
              tl: {
                hd: /* '_' */95,
                tl: {
                  hd: Stdlib__Char.lowercase_ascii(c2),
                  tl: map(match.tl)
                }
              }
            };
    } else {
      return {
              hd: c1,
              tl: map(param.tl)
            };
    }
  };
  return Stdlib__String.of_seq(Stdlib__List.to_seq(map(Stdlib__List.of_seq(Stdlib__String.to_seq(s)))));
}

function value_to_json(json) {
  let value;
  if (typeof json === "string") {
    value = [
      "nullValue",
      json
    ];
  } else {
    const variant = json.NAME;
    value = variant === "Int" || variant === "Float" ? [
        "numberValue",
        json
      ] : (
        variant === "Bool" ? [
            "boolValue",
            json
          ] : (
            variant === "List" ? [
                "listValue",
                json
              ] : (
                variant === "Assoc" ? [
                    "structValue",
                    json
                  ] : [
                    "stringValue",
                    json
                  ]
              )
          )
      );
  }
  return {
          NAME: "Assoc",
          VAL: {
            hd: value,
            tl: /* [] */0
          }
        };
}

function map_enum_json(Enum) {
  const name = Stdlib__StringLabels.concat(".", Stdlib__ListLabels.tl(Stdlib__StringLabels.split_on_char(/* '.' */46, Curry._1(Enum.name, undefined))));
  if (name === "google.protobuf.NullValue") {
    return function (json) {
      if (json === "Null") {
        return {
                NAME: "String",
                VAL: Curry._1(Enum.to_string, Curry._1(Enum.from_int_exn, 0))
              };
      } else {
        return value_error(name, json);
      }
    };
  } else {
    return function (json) {
      return json;
    };
  }
}

function map_message_json(name) {
  switch (name) {
    case ".google.protobuf.Duration" :
        return function (json) {
          const match = duration_of_json(json);
          return {
                  NAME: "Assoc",
                  VAL: {
                    hd: [
                      "seconds",
                      {
                        NAME: "Int",
                        VAL: match[0]
                      }
                    ],
                    tl: {
                      hd: [
                        "nanos",
                        {
                          NAME: "Int",
                          VAL: match[1]
                        }
                      ],
                      tl: /* [] */0
                    }
                  }
                };
        };
    case ".google.protobuf.Empty" :
        return function (json) {
          return json;
        };
    case ".google.protobuf.FieldMask" :
        return function (json) {
          if (typeof json === "string") {
            return value_error(name, json);
          }
          if (json.NAME !== "String") {
            return value_error(name, json);
          }
          const masks = Stdlib__ListLabels.map((function (s) {
                  return {
                          NAME: "String",
                          VAL: s
                        };
                }), Stdlib__ListLabels.map(from_camel_case, Stdlib__StringLabels.split_on_char(/* ',' */44, json.VAL)));
          return {
                  NAME: "Assoc",
                  VAL: {
                    hd: [
                      "paths",
                      {
                        NAME: "List",
                        VAL: masks
                      }
                    ],
                    tl: /* [] */0
                  }
                };
        };
    case ".google.protobuf.ListValue" :
        return function (json) {
          if (typeof json === "string" || json.NAME !== "List") {
            return value_error(name, json);
          } else {
            return {
                    NAME: "Assoc",
                    VAL: {
                      hd: [
                        "values",
                        json
                      ],
                      tl: /* [] */0
                    }
                  };
          }
        };
    case ".google.protobuf.Struct" :
        return function (json) {
          if (typeof json === "string" || json.NAME !== "Assoc") {
            return value_error(name, json);
          } else {
            return {
                    NAME: "Assoc",
                    VAL: {
                      hd: [
                        "fields",
                        json
                      ],
                      tl: /* [] */0
                    }
                  };
          }
        };
    case ".google.protobuf.Timestamp" :
        return function (json) {
          const match = timestamp_of_json(json);
          const nanos = match[1];
          const seconds = match[0];
          if (Stdlib__Sys.int_size < 63) {
            return {
                    NAME: "Assoc",
                    VAL: {
                      hd: [
                        "seconds",
                        {
                          NAME: "String",
                          VAL: Stdlib__Int64.to_string(seconds)
                        }
                      ],
                      tl: {
                        hd: [
                          "nanos",
                          {
                            NAME: "String",
                            VAL: Stdlib__Int64.to_string(nanos)
                          }
                        ],
                        tl: /* [] */0
                      }
                    }
                  };
          } else {
            return {
                    NAME: "Assoc",
                    VAL: {
                      hd: [
                        "seconds",
                        {
                          NAME: "Int",
                          VAL: Caml_int64.to_int32(seconds)
                        }
                      ],
                      tl: {
                        hd: [
                          "nanos",
                          {
                            NAME: "Int",
                            VAL: Caml_int64.to_int32(nanos)
                          }
                        ],
                        tl: /* [] */0
                      }
                    }
                  };
          }
        };
    case ".google.protobuf.BoolValue" :
    case ".google.protobuf.BytesValue" :
    case ".google.protobuf.DoubleValue" :
    case ".google.protobuf.FloatValue" :
    case ".google.protobuf.Int32Value" :
    case ".google.protobuf.Int64Value" :
    case ".google.protobuf.StringValue" :
    case ".google.protobuf.UInt32Value" :
    case ".google.protobuf.UInt64Value" :
        break;
    case ".google.protobuf.Value" :
        return value_to_json;
    default:
      return function (json) {
        return json;
      };
  }
  return function (json) {
    return {
            NAME: "Assoc",
            VAL: {
              hd: [
                "value",
                json
              ],
              tl: /* [] */0
            }
          };
  };
}

function read_value(Enum) {
  if (typeof Enum === "number") {
    switch (Enum) {
      case /* Double */0 :
      case /* Float */1 :
          return to_float;
      case /* Int32 */2 :
      case /* UInt32 */3 :
      case /* SInt32 */4 :
      case /* Fixed32 */5 :
      case /* SFixed32 */6 :
          return to_int32;
      case /* UInt64 */12 :
      case /* Int64 */13 :
      case /* SInt64 */14 :
      case /* Fixed64 */15 :
      case /* SFixed64 */16 :
          return to_int64;
      case /* Bool */22 :
          return to_bool;
      case /* String */23 :
          return to_string;
      case /* Bytes */24 :
          return to_bytes;
      default:
        return to_int;
    }
  } else {
    if (Enum.TAG !== /* Enum */0) {
      return Enum._0.from_json_exn;
    }
    const Enum$1 = Enum._0;
    const map_enum_json$1 = map_enum_json(Enum$1);
    return function (json) {
      let json$1 = Curry._1(map_enum_json$1, json);
      if (typeof json$1 === "string") {
        return value_error("enum", json$1);
      }
      const variant = json$1.NAME;
      if (variant === "String") {
        return Curry._1(Enum$1.from_string_exn, json$1.VAL);
      } else if (variant === "Int") {
        return Curry._1(Enum$1.from_int_exn, json$1.VAL);
      } else {
        return value_error("enum", json$1);
      }
    };
  }
}

function find_field(param, fields) {
  const value = Curry._2(FieldMap.find_opt, param[2], fields);
  if (value !== undefined) {
    return Caml_option.some(Caml_option.valFromOption(value));
  } else {
    return Curry._2(FieldMap.find_opt, param[1], fields);
  }
}

function read(param) {
  switch (param.TAG | 0) {
    case /* Basic */0 :
        const $$default = param._2;
        const index = param._0;
        const read_value$1 = read_value(param._1);
        return function (fields) {
          const field = find_field(index, fields);
          if (field !== undefined) {
            return Curry._1(read_value$1, field);
          } else {
            return $$default;
          }
        };
    case /* Basic_opt */1 :
        const index$1 = param._0;
        const read_value$2 = read_value(param._1);
        return function (fields) {
          const field = find_field(index$1, fields);
          if (field !== undefined) {
            return Caml_option.some(Curry._1(read_value$2, field));
          }
          
        };
    case /* Basic_req */2 :
        const index$2 = param._0;
        const read_value$3 = read_value(param._1);
        return function (fields) {
          const field = find_field(index$2, fields);
          if (field !== undefined) {
            return Curry._1(read_value$3, field);
          } else {
            return Ocaml_protoc_plugin__Result.raise({
                        NAME: "Required_field_missing",
                        VAL: [
                          0,
                          ""
                        ]
                      });
          }
        };
    case /* Repeated */3 :
        const index$3 = param._0;
        const read$1 = read_value(param._1);
        return function (fields) {
          const field = find_field(index$3, fields);
          if (field !== undefined) {
            return Stdlib__ListLabels.map(read$1, to_list(field));
          } else {
            return /* [] */0;
          }
        };
    case /* Map */4 :
        const match = param._1;
        const match$1 = match[1];
        const key_spec = match[0];
        const index$4 = param._0;
        if (match$1.TAG === /* Basic */0) {
          const read_key = read_value(key_spec);
          const read_key$1 = function (v) {
            return Curry._1(read_key, {
                        NAME: "String",
                        VAL: v
                      });
          };
          const read_value$4 = read_value(match$1._1);
          return function (fields) {
            const field = find_field(index$4, fields);
            if (field !== undefined) {
              return read_map(read_key$1, read_value$4, field);
            } else {
              return /* [] */0;
            }
          };
        }
        const read_key$2 = read_value(key_spec);
        const read_key$3 = function (v) {
          return Curry._1(read_key$2, {
                      NAME: "String",
                      VAL: v
                    });
        };
        const read_value$5 = read_value(match$1._1);
        const read_value$6 = function (json) {
          if (json !== "Null") {
            return Caml_option.some(Curry._1(read_value$5, json));
          }
          try {
            return Caml_option.some(Curry._1(read_value$5, "Null"));
          }
          catch (exn){
            return ;
          }
        };
        return function (fields) {
          const field = find_field(index$4, fields);
          if (field !== undefined) {
            return read_map(read_key$3, read_value$6, field);
          } else {
            return /* [] */0;
          }
        };
    case /* Oneof */5 :
        const make_readers = function (param) {
          if (!param) {
            return /* [] */0;
          }
          const match = param.hd;
          const constr = match._2[0];
          const read$2 = read({
                TAG: /* Basic_opt */1,
                _0: match._0,
                _1: match._1
              });
          const read_opt = function (fields) {
            const v = Curry._1(read$2, fields);
            if (v !== undefined) {
              return Caml_option.some(Curry._1(constr, Caml_option.valFromOption(v)));
            }
            
          };
          return {
                  hd: read_opt,
                  tl: make_readers(param.tl)
                };
        };
        const readers = make_readers(param._0[0]);
        return function (fields) {
          let _param = readers;
          while(true) {
            const param = _param;
            if (!param) {
              return "not_set";
            }
            const v = Curry._1(param.hd, fields);
            if (v !== undefined) {
              return v;
            }
            _param = param.tl;
            continue ;
          };
        };
    
  }
}

function deserialize(_extension_ranges) {
  if (typeof _extension_ranges === "number") {
    return function (constr, _json) {
      return constr;
    };
  }
  if (_extension_ranges.TAG === /* Nil_ext */0) {
    return function (constr, _json) {
      return Curry._1(constr, /* [] */0);
    };
  }
  const read$1 = read(_extension_ranges._0);
  const cont = deserialize(_extension_ranges._1);
  return function (constr, fields) {
    const v = Curry._1(read$1, fields);
    return Curry._2(cont, Curry._1(constr, v), fields);
  };
}

function deserialize$1(message_name, spec, constr) {
  const partial_arg = deserialize(spec);
  const map_message = map_message_json(message_name);
  return function (json) {
    const json$1 = Curry._1(map_message, json);
    if (typeof json$1 === "string" || json$1.NAME !== "Assoc") {
      return value_error("message", json$1);
    } else {
      let param = Stdlib__ListLabels.fold_left((function (map, param) {
              return Curry._3(FieldMap.add, param[0], param[1], map);
            }), FieldMap.empty, json$1.VAL);
      return partial_arg(constr, param);
    }
  };
}

export {
  deserialize$1 as deserialize,
  to_int64 ,
  to_int32 ,
  to_int ,
  to_string ,
  to_bytes ,
  to_float ,
  to_bool ,
  to_list ,
}
/* FieldMap Not a pure module */
